import Axios from 'axios'

export default function setup () {
  Axios.interceptors.request.use(function (config) {
    let auth = JSON.parse(localStorage.getItem('user'))
    if (auth && auth.token) {
      config.headers.Authorization = `Bearer ${auth.token}`
    }
    return config
  }, function (err) {
    return Promise.reject(err)
  })
}



// WEBPACK FOOTER //
// ./src/_api/axiosInterceptor.js